<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner3.png">
        <div class="box-font">企业新闻</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='Category' :list='News_menulist' @datashow=listshow></leftmenu>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div style="margin-left: 20px;padding:20px;width:100%; border: 1px solid #CCCCCC;">
          <h3 style="text-align: center;">{{ detail.Title }}</h3>
          <p style="text-align: center;font-size: 16px;">{{ detail.CreateTime.slice(0, 10) }}</p>
          <!-- <a style="float: right;padding-right: 30px;color:red;" :href="detail.Annex" v-show="detail.Annex">下载附件</a> -->
          <div style="padding-top: 30px;" v-html=detail.Content></div>
        </div>

      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftlogin from "../components/leftlogin.vue";
import leftmenu from "../components/leftmenu.vue";
export default {
  name: "Newsdetail",
  components: { leftlogin, leftmenu },
  data() {
    return {
      News_menulist: [{
        "Word_Text": "企业新闻", "Id": 1, "Word_Value": 1
      }, {
        "Word_Text": "公司业绩", "Id": 2, "Word_Value": 2
      }, {
        "Word_Text": "通知公告", "Id": 3, "Word_Value": 3
      }],
      detail: {},
      Id: 0,
      Category: 0,
      form: {
        name: "",
        pass: "",
        type: ""
      }
    };
  },
  created() {
    var that = this;
    that.Category = that.$route.query.type;
    that.Id = that.$route.query.id;
    var list = that.News_menulist.filter(function (item) {
      return item.Word_Value == that.Category
    });
    if (list.length > 0) {
      if (that.Category == 1) that.getData();
      else if (that.Category == 2) that.getData2();
      else that.getData3();
    }
  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/News/" + that.Id, null, r => {
        that.detail = r.response;
      });
    },
    getData2() {
      var that = this;
      that.$api.get("/Performance/" + that.Id, null, r => {
        that.detail = r.response;
      });
    },
    getData3() {
      var that = this;
      that.$api.get("/Impart/" + that.Id, null, r => {
        that.detail = r.response;
      });
    },
    listshow(item) {
      this.$router.replace("/News?type=" + item.Word_Value);
      return false;
    }
  },
  watch: {
    $route(to) {
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}
</style>
